import Layout from '@/components/Layout';
import Production from '@/components/Production';
import styles from '@/components/Production/production.module.scss';
import API from '../../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// Заглушка для переводов
const translate = s => s;

const Catalog = ({ data }) => {
  return <Production data={data} />;
};

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('Категории'), route: '/catalog' },
];

Catalog.getLayout = (page, t) => (
  <Layout
    paddings={false}
    page={page.props}
    customPaddings={styles.paddings}
    breadcrumbs={breadcrumbs}
    title={t('Каталог продукции — UNIFROST')}
  >
    {page}
  </Layout>
);

export async function getServerSideProps(context) {
  const props = { data: { categories: [] } };

  try {
    const res = await API.get(`/v1/api/pages/catalog/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (res.status === 200) {
      if (res.data) props.data = res.data;
    }
  } catch (error) {}

  try {
    const resCategories = await API.get(`/v1/api/products/categories/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (resCategories.status === 200 && Array.isArray(resCategories.data)) {
      if (resCategories.data) props.data.categories = resCategories.data;
    }
  } catch (error) {}

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu', 'products'])),
    },
    // revalidate: 60,
  };
}

export default Catalog;
